import {Directive, ElementRef, HostListener, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[oxStateInput]'
})

export class StateInputDirective implements OnInit {
  constructor(private labelElement: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(){
    this.changeElem();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.changeElem();
  }


  public changeElem() {
    //Parse the width as an integer to compare the numeric values.
    const integer = parseInt(this.labelElement.nativeElement.style.width, 10);
    if (integer > 250) {
      // increase padding
      this.renderer.setStyle(this.labelElement.nativeElement, 'padding', '0 15px');
    }
  }
}
